export const BUSINESS = {
  name: "Optima Electrical Solutions",
  legal: "Optima Electrical Solutions Ltd",
  owner: "Ernest Kwiatek",
  phone: "07511 625975",
  phoneRaw: "+447511625975",
  email: "Optimaelectricalsolutionsltd@gmail.com",
  ownerEmail: "ernest12101210@gmail.com",
  facebook: "https://www.facebook.com/people/Optima-Electrical-Solutions-Ltd/",
  facebookLabel: "Optima Electrical Solutions Ltd",
  location: "Medway, Kent",
  logo: "https://customer-assets.emergentagent.com/job_medway-electric/artifacts/vdn3b40d_Screenshot_20260531_190538_Gallery.jpg",
};

export const SERVICE_AREAS = [
  "Chatham", "Gillingham", "Rochester", "Strood", "Rainham",
  "Maidstone", "Sittingbourne", "Gravesend", "Hoo", "Walderslade",
  "Lordswood", "Cuxton", "Snodland", "Aylesford",
];
